import React, { useContext } from "react";
import { Route, Switch } from "react-router-dom";
import { LoggedUserContext } from "ui/componentes";
import { PrivateRoute } from "ui/componentes/PrivateRoute";
import { PageNotFound } from "ui/views";
import { Routes } from "./Routes";

const Router = () => {
    const loggedUser = useContext(LoggedUserContext);
    return (
        <Switch>
            {Routes.filter((route) => {
                if (!route.component) {
                    return false;
                }
                // if (route.roles) {
                //     return route.roles.some((role) =>
                //         loggedUser.roles.includes(role)
                //     );
                // }
                return true;
            }).map((routeObj) => {
                const { route, component: Component, privateRoute } = routeObj;

                if (privateRoute) {
                    return (
                        <PrivateRoute
                            key={route}
                            path={route}
                            exact
                            component={Component}
                        />
                    );
                }
                return (
                    <Route
                        key={route}
                        path={route}
                        exact
                        render={() => <Component />}
                    />
                );
            })}
            <Route path="*" component={PageNotFound} />
        </Switch>
    );
};

export default Router;
